import React from "react";
import { useSelector } from "react-redux";

import styles from "../funnelChart.module.css";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export function IntroOfferDataPoints() {
  const combinedStats = useSelector((state) => state.laser.funnelIntroOffers.combinedStats);
  const averageTooltip = useSelector((state) => state.laser.averageTooltip);

  if (!combinedStats.length) return null;

  return (
    <>
      <div className="section-group flex">
        {combinedStats.map((combinedStat, index) => (
          <div className={styles.statsItemContainer} key={`combinedStat-${index}`}>
            {combinedStat.map((singleStat, singleStatIndex) =>
              !singleStat ? (
                <div key={`singleStat-${singleStatIndex}`} />
              ) : (
                <DataDisplay
                  key={singleStat.label}
                  label={singleStat.label}
                  value={singleStat.value}
                  url={singleStat.url}
                  averageProps={{ average: singleStat.average, toolTip: averageTooltip }}
                  sectionProps={{
                    style: { paddingRight: "100px" },
                    rootClassName: styles.statsItem
                  }}
                  disableAnimation
                />
              )
            )}
          </div>
        ))}
      </div>
    </>
  );
}
